const articleProductionStatuses = {
	NOT_STARTED: "not_started",
	ONGOING: "ongoing",
	COMPLETED: "completed",
};

export default articleProductionStatuses;
